import React from "react";
import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import Background from "../Background/Background";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Layout = ({ children }) => {
    const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

    return (
    <div className="relative min-h-screen flex flex-col">
      {/* Background Animation */}
      <Background />

      {/* Header */}
      <Header />

      {/* Main Content */}
      <ToastContainer position="top-right" autoClose={3000} />
      <main className="flex-grow container mx-auto px-6 pt-16">{children}</main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
